import type { ITableBodyLoaderProps } from './Table.helpers';

const TableBodyLoader = ({ skeletonRows, skeletonColumns }: ITableBodyLoaderProps) => (
	<tbody>
		{Array.from({ length: skeletonRows }).map((_, index) => (
			<tr
				key={`table-plain-body-row-skeleton-${String(index)}`}
				className='bg-primary-500-hover'
			>
				{Array.from({ length: skeletonColumns }).map((__, colIndex) => (
					<td key={`table-plain-body-cell-skeleton-${String(index)}-${String(colIndex)}`}>
						<div
							className='global-skeleton'
							style={{ width: '100%' }}
						>
							loading...
						</div>
					</td>
				))}
			</tr>
		))}
	</tbody>
);

export default TableBodyLoader;
